
export default {
  state: {
    keepAlive:['index']
  },
  mutations: {
    setKeepAlive: (state, keepAlive) => {
        state.keepAlive = keepAlive
    }
  },
  getters: {
    keepAlive: state => state.keepAlive
  }
}
